/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WebApiEndpointsUsersUpdateRequest { 
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    salesRepresentativeId?: string | null;
    employerId?: string | null;
    roleIds?: Array<string> | null;
}

